import { render, staticRenderFns } from "./homeBanner.vue?vue&type=template&id=21a74b0a&scoped=true&"
import script from "./homeBanner.vue?vue&type=script&lang=js&"
export * from "./homeBanner.vue?vue&type=script&lang=js&"
import style0 from "./homeBanner.vue?vue&type=style&index=0&id=21a74b0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a74b0a",
  null
  
)

export default component.exports